module.exports = __webpack_public_path__ + "img/ONR.9f5ae403.svg";